module.exports = __webpack_public_path__ + "media/svg/tc-cb4d68eb.svg";